import {
  getPlanAllowsCompanyPurchase,
  getPlanFee,
} from "./planAccessors";

export function normalizeInvoiceTaxCode(invoiceTaxCode) {
  const normalized = String(invoiceTaxCode || "").trim();
  return normalized === "" ? "0" : normalized;
}

export function requiresIndividualPurchaseConfirmation(plan, invoiceTaxCode) {
  return (
    plan &&
    getPlanFee(plan) > 0 &&
    getPlanAllowsCompanyPurchase(plan) === false &&
    normalizeInvoiceTaxCode(invoiceTaxCode) !== "0"
  );
}

export function getIndividualPurchaseConfirmationMessage() {
  return (
    "Ez a csomag nem vásárolható céges előfizetésként.\n\n" +
    "A vásárlás csak magánszemélyként folytatható, áfával növelt áron. " +
    "Ebben az esetben a megadott adószám nem kerül felhasználásra ennél az előfizetésnél.\n\n" +
    "Elfogadod a magánszemély előfizetést?"
  );
}
